import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpenPreviewTagDetail from '../../../views/app/common/OpenPreviewTagDetail';
import { appActions } from '../../../store/modules/app';

class OpenPreviewTagDetailContainer extends Component {
  render() {
    return <OpenPreviewTagDetail {...this.props} />;
  }
}

const mapDispatchToProps = {
  getTagPreviewData: appActions.getTagPreviewData,
};

export default connect(null, mapDispatchToProps)(OpenPreviewTagDetailContainer);
